import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnChanges {

  // Propiedades de configuración
  @Input() show = false;
  @Input() text = '';
  @Input() type: 'fullscreen' | 'absolute' | 'inline' = 'absolute';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() color = '#124E91';
  @Input() trackColor?: string;
  @Input() blurBackground = true;
  @Input() showText = true;
  @Input() animationStyle: 'default' | 'scale' = 'default';

  /** Modo de render: spinner circular o barra de progreso. */
  @Input() variant: 'spinner' | 'bar' = 'spinner';
  /** Progreso 0-100. Si es null/undefined la barra es indeterminada. */
  @Input() progress: number | null = null;
  /** Texto específico de la barra (si no se usa `text`). */
  @Input() progressText = '';
  /** Aviso secundario (ej. conexión lenta) que se muestra bajo la barra. */
  @Input() hint = '';

  // Clases dinámicas
  overlayClass = '';
  contentClass = '';

  // Tamaños del spinner
  spinnerSize = 50;
  borderWidth = 5;

  ngOnInit(): void {
    this.setStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['size'] || changes['type'] || changes['animationStyle']) {
      this.setStyles();
    }
  }
  
  private setStyles(): void {
    // Configurar tamaño
    switch (this.size) {
      case 'small':
        this.spinnerSize = 30;
        this.borderWidth = 3;
        break;
      case 'medium':
        this.spinnerSize = 50;
        this.borderWidth = 5;
        break;
      case 'large':
        this.spinnerSize = 70;
        this.borderWidth = 6;
        break;
    }
    
    // Configurar clases
    this.overlayClass = `custom-modal-overlay spinner-${this.type}`;
    this.contentClass = `custom-modal-content ${this.animationStyle === 'scale' ? 'spinner-animation-scale' : ''}`;
  }
  
  /** Progreso normalizado 0-100, o null si es indeterminado. */
  get barProgress(): number | null {
    if (this.progress === null || this.progress === undefined || isNaN(this.progress as any)) {
      return null;
    }
    return Math.max(0, Math.min(100, Math.round(this.progress)));
  }

  get barIndeterminate(): boolean {
    return this.barProgress === null;
  }

  get barLabel(): string {
    return this.progressText || this.text;
  }

  // Método para mostrar/ocultar programáticamente
  public toggle(show?: boolean): void {
    if (show !== undefined) {
      this.show = show;
    } else {
      this.show = !this.show;
    }
  }
}
